import TechSectionHeader from "./TechSectionHeader";
import TechStackGrid from "./TechStackGrid";
import { cloudTech } from "./technologies.data";

export default function TechCloudDevOps() {
  return (
    <section className="tech-section">
      <TechSectionHeader
        title="Cloud &"
        highlight="DevOps"
        subtitle="Scalable infrastructure, automated deployments, and high availability."
      />

      <TechStackGrid items={cloudTech} />
    </section>
  );
}
